<template>
    <div class="pt-3">
        <anexo :anexos.sync="fornecedor.documentosSolicitados"
               :protocolo="getRelatorioProtocolo"
               :situacaoCompraDireta="resumoProposta.situacao"
               :tipoCompraDireta="resumoProposta.tipo"
               :disputaCompraDireta="resumoProposta.disputaPor"
               :protocoloAssinado="resumoProposta.isProtocoloAssinado"
               :idProtocoloVirtualizado="resumoProposta.idProtocoloVirtualizado"
               :urlProtocoloVirtualizado="resumoProposta.urlProtocoloVirtualizado"
               :isProtocoloSolicitadoAssinatura="resumoProposta.isProtocoloSolicitadoAssinatura"
               :termo="getTermoAceite"
               :situacaoReajuste="fornecedor.meusItensELotesVencedoresAReajustar.situacaoReajuste"
               @adicionarAnexo="adicionarAnexo"
               @enviarAnexos="tratarEventoAbrirConfirmacao"
               @gerarRelatorioProtocolo="gerarRelatorioProtocolos"
               @removerDocumento="tratarEventoRemoverDocumento"
               @downloadAnexo="tratarEventDownloadAnexo"
               @downloadTermoAceite="downloadTermoAceite(...arguments)"
               @gerarRelatorioProtocoloPreview="gerarRelatorioProtocoloPreview"/>

        <reajuste v-if="exibirReajuste"
                  :reajusteItens.sync="fornecedor.meusItensELotesVencedoresAReajustar.reajusteItens"
                  :reajusteLotes.sync="fornecedor.meusItensELotesVencedoresAReajustar.reajusteLotes"
                  :relatorioReajuste="fornecedor.meusItensELotesVencedoresAReajustar.relatorioReajuste"
                  :anexoReadequacao.sync="anexoReadequacao"
                  :solicitadoAssinatura="fornecedor.meusItensELotesVencedoresAReajustar.solicitadoAssinatura"
                  :reajusteAssinado="fornecedor.meusItensELotesVencedoresAReajustar.reajusteAssinado"
                  :idVirtualizado="fornecedor.meusItensELotesVencedoresAReajustar.idVirtualizado"
                  :urlVirtualizacaoReajuste="fornecedor.meusItensELotesVencedoresAReajustar.urlVirtualizacaoReajuste"
                  :situacao-reajuste="fornecedor.meusItensELotesVencedoresAReajustar.situacaoReajuste"
                  :valor-final-proposta="fornecedor.meusItensELotesVencedoresAReajustar.valorFinalProposta"
                  :situacaoCompraDireta="resumoProposta.situacao"
                  :tipoCompraDireta="resumoProposta.tipo"
                  :disputaCompraDireta="resumoProposta.disputaPor"
                  :casasDecimais="quantidadeCasasDecimais"
                  :casasDecimaisQuantidade="resumoProposta.casasDecimaisQuantidade"
                  :aceita-valor-zero="aceitaValorZero"
                  :criterioJulgamento="criterioJulgamento"
                  :simboloCriterioJulgamento="simboloCriterioJulgamento"
                  :prefixSuffixValor="prefixSuffixValor"
                  :validarLancesPor="validarLancesPor"
                  @propagarEventoEnviarAnexoReadequacao="eventoEnviarAnexoReadequacao"
                  @resetAnexoReadequacao="resetAnexoReadequacao"
                  @atualizarReadequacaoItemLote="atualizarReadequacaoItemLote"
                  @irParaProximaPagina="irParaProximaPagina"
                  @irParaPaginaAnterior="irParaPaginaAnterior"
                  @salvarItemLote="salvarItemLote"
                  @enviarReajusteLote="finalizarReajusteLote"
                  @enviarNegociacao="enviarNegociacao"
                  @gerarRelatorioReajustes="gerarRelatorioReajustes"/>

      <mensagem-confirmacao :exibirMensagem="mostrarDialogoConfirmacao"
                            titulo="Enviar documentos para análise "
                            textoSecundario="Essa ação envia todos os documentos anexados para análise.
                                Deseja realmente enviar?"
                            @confirmado="tratarEventoDeEnviarAnexos"
                            @recusado="fecharDialogoConfirmacao"/>

      <mensagem-confirmacao-com-lista :exibirMensagem="mostrarDialogoConfirmacaoDocumentosNaoAnexados"
                                      titulo="Enviar documentos para análise"
                                      textoPrimario="Os documentos a seguir não foram anexados. Deseja enviar mesmo assim ?"
                                      :textoSecundario="textoSecundarioDocumentosNaoAnexados"
                                      botaoConfirmar="Sim, Enviar !"
                                      botaoRecusar="Não, Voltar !"
                                      tamanhoMaximo="600"
                                      @confirmado="tratarEventoDeEnviarAnexos"
                                      @recusado="fecharDialogoConfirmacao"/>
    </div>
</template>

<script>
import SmartTimerMixin from '@/core/mixins/SmartTimerMixin'
import {mapState} from 'vuex'
import {actionTypes} from '@/core/constants'
import azCurrency from '@azinformatica/loki/src/utils/AzCurrency'
import Anexo from './anexo/Anexo'
import Reajuste from './reajuste/Reajuste'
import MensagemConfirmacaoComLista from '@/views/components/MensagemConfirmacaoComLista'

export default {
    name: 'DocumentoProposta',
    mixins: [SmartTimerMixin],
    components: {
        MensagemConfirmacaoComLista,
        Anexo,
        Reajuste
    },
    data() {
        return {
            mostrarDialogoConfirmacao: false,
            mostrarDialogoConfirmacaoDocumentosNaoAnexados: false,
            textoSecundarioDocumentosNaoAnexados: [],
            compraDiretaId: null,
            propostaId: null,
            exibirReajuste: false,
            anexoReadequacao: null
        }
    },
    computed: {
        ...mapState(['fornecedor', 'resumoProposta', 'parametros', 'loki']),
        quantidadeCasasDecimais() {
            return this.fornecedor.quantidadeCasasDecimaisCompraDireta
        },
        aceitaValorZero(){
            return this.parametros.propriedadesCompraDiretas.fornecedor.proposta.aceitarValorZero
        },
        uploadedFiles(){
            return this.loki.uploadedFiles
        },
        criterioJulgamento(){
            return this.resumoProposta.criterioJulgamento
        },
        simboloCriterioJulgamento(){
            return this.resumoProposta.simboloCriterioJulgamento
        },
        prefixSuffixValor(){
            return this.resumoProposta.prefixoValor
        },
        validarLancesPor(){
            return this.resumoProposta.intervaloLancesPor
        },
        getTermoAceite(){
            return this.resumoProposta.termo ? this.resumoProposta.termo : {}
        },
        getRelatorioProtocolo(){
            return this.resumoProposta.protocolo ? this.resumoProposta.protocolo : {}
        }
    },
    async mounted() {
        try {
            this.setCompraDiretaIdEPropostaId()
            await this.buscarAnexos()
            await this.buscarItensELotesVencedoresAReajustar()
        } catch (e) {
            this.mostrarNotificacaoErro(e.message)
        }
        this.exibirReajuste = true
        
        this.createSmartTimer('verificarSePodeAtualizarDados', 'verificarSePodeAtualizarDados', 2000, {
            autostart: true,
            immediate: true
        })
    },
    methods: {
        async finalizarReajusteLote(reajusteLote) {
            const objetoRequisicao = {
                compraDiretaId: this.compraDiretaId,
                loteCompraDiretaId: reajusteLote.loteCompraDiretaId
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.ENVIAR_REAJUSTE_LOTE, objetoRequisicao)
            await this.buscarItensELotesVencedoresAReajustar()
            this.mostrarNotificacaoSucesso('Reajuste enviado com sucesso.')
        },
        async buscarAnexos() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_DOCUMENTOS_SOLICITADOS_DA_PROPOSTA,
                this.compraDiretaId)
        },
        tratarEventoAbrirConfirmacao() {
            if(this.existeDocumentosNaoAnexados())
                this.mostrarDialogoConfirmacaoDocumentosNaoAnexados = true
            else
                this.mostrarDialogoConfirmacao = true
        },
        fecharDialogoConfirmacao() {
            this.mostrarDialogoConfirmacao = false
            this.mostrarDialogoConfirmacaoDocumentosNaoAnexados = false
        },
        async tratarEventoDeEnviarAnexos() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.ENVIAR_DOCUMENTOS_ANALISE, this.compraDiretaId)
            this.fecharDialogoConfirmacao()
            await this.buscarAnexos()
            this.mostrarNotificacaoSucesso('Documentos enviados para análise.')
        },
        existeDocumentosNaoAnexados() {
            const documentosSolicitados = this.fornecedor.documentosSolicitados

            if(documentosSolicitados.every((documento) => !documento.uri))
                throw new Error('Por favor, anexe pelo menos 1 arquivo para continuar !')

            this.textoSecundarioDocumentosNaoAnexados = documentosSolicitados.filter((documento) => !documento.uri).map((documento) => documento.descricao)

            return this.textoSecundarioDocumentosNaoAnexados.length > 0
        },
        async adicionarAnexo(arquivo) {
            const anexoObj = {
                compraDiretaId: this.compraDiretaId,
                arquivo
            }

            if (!arquivo.documentoSolicitadoId) {
                this.mostrarNotificacaoErro('Ausência do Id do documento solicitado.')
                return
            }

            try {
                await this.$store.dispatch(actionTypes.FORNECEDOR.ADICIONAR_ANEXO_DOCUMENTO_SOLICITADO_DA_PROPOSTA, anexoObj)
                this.mostrarNotificacaoSucesso('Arquivo anexado com sucesso.')
            } catch (e) {
                this.mostrarNotificacaoErro('Erro ao adicionar anexo aos documentos solicitado da proposta')
            }
            this.buscarAnexos()
        },
        async tratarEventoRemoverDocumento(documento) {
            const objetoParaRemover ={
                compraDiretaId: this.compraDiretaId,
                documentoApresentadoId: documento.id
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.REMOVER_DOCUMENTO_APRESENTADO, objetoParaRemover)
            this.mostrarNotificacaoSucesso('Arquivo removido com sucesso.')
        },
        async downloadTermoAceite(termo, tipoDownload) {
            if(termo && (termo.idVirtualizado && termo.virtualizado)) {
                const dados = {
                    documentoVirtualizadoId: termo.idVirtualizado,
                    nomeArquivo: termo.nome,
                    opcaoDownloadVirtualizacao: tipoDownload,
                    compraDiretaId: this.compraDiretaId,
                    uri: ('ORIGINAL' === tipoDownload) ? termo.urlFileManager : null,
                    noProcessoDigital: true
                }
                await this.$store.dispatch(actionTypes.FORNECEDOR.BAIXAR_RELATORIO_TERMO_VIRTUALIZADO, dados)
            } else {
                await this.$store.dispatch(actionTypes.FORNECEDOR.BAIXAR_TERMO_ACEITE_PROPOSTA, this.propostaId)
            }
        },
        async buscarItensELotesVencedoresAReajustar() {
            await this.$store.dispatch(actionTypes.FORNECEDOR.BUSCAR_ITENS_E_LOTES_VENCEDORES_A_REAJUSTAR,
                this.compraDiretaId)
        },
        async salvarItemLote(item) {
            const valorObj = {
                compraDiretaId: this.compraDiretaId,
                item: {
                    id: item.id,
                    itemCompraDiretaId: item.itemCompraDiretaId,
                    reajusteLotePropostaId: item.reajusteLotePropostaId,
                    loteCompraDiretaId: item.loteCompraDiretaId,
                    reajustePropostaId: item.reajustePropostaId,
                    valorUnitarioReajustado: item.valorUnitarioReajustado
                }
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.SALVAR_ITEM_DO_REAJUSTE, valorObj)
        },
        async enviarNegociacao(comboDecisao) {
            const decisaoObj = {
                compraDiretaId: this.compraDiretaId,
                id: comboDecisao.id,
                itemOuLoteReajusteId: comboDecisao.itemOuLoteReajusteId,
                itemOuLoteCompraDiretaId: comboDecisao.itemOuLoteCompraDiretaId,
                tipo: comboDecisao.tipo,
                aceito: comboDecisao.aceito,
                valor: comboDecisao.valor
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.DECIDIR_NEGOCIACAO_LOTE_OU_ITEM_DO_REAJUSTE, decisaoObj)
            if (comboDecisao.aceito) {
                const valor = azCurrency.formatarMoeda(decisaoObj.valor, this.quantidadeCasasDecimais)
                if(this.criterioJulgamento === 'MENOR_PRECO') {
                    this.mostrarNotificacaoSucesso(`Negociação no valor de R$ ${valor} enviada com sucesso.`)
                } else {
                    this.mostrarNotificacaoSucesso(`Negociação no valor de ${valor} % enviada com sucesso.`)
                }

            } else {
                this.mostrarNotificacaoSucesso('Negociação recusada com sucesso')
            }
            await this.buscarItensELotesVencedoresAReajustar()
        },
        async verificarSePodeAtualizarDados() {
            if (['EM_ANALISE', 'REANALISE'].includes(this.resumoProposta.situacao)){
                await this.buscarAnexos()
                await this.buscarItensELotesVencedoresAReajustar()
            }
        },
        setCompraDiretaIdEPropostaId() {
            this.compraDiretaId = this.$route.params.id
            this.propostaId = this.$route.params.propostaId
        },
        irParaPaginaAnterior() {
            this.$router.push({name: 'DetalhesCompraDireta', params: this.compraDiretaId})
        },
        irParaProximaPagina() {
            this.$router.push({
                name: 'ResultadoFinalDoFornecedor',
                params: {
                    id: this.compraDiretaId,
                    propostaId: this.propostaId
                }
            })
        },
        async gerarRelatorioProtocolos(idVirtualizado, opcaoDownloadVirtualizacao) {
            const infoObj = {
                idVirtualizado: idVirtualizado,
                opcaoDownloadVirtualizacao: opcaoDownloadVirtualizacao
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.BAIXAR_RELATORIO_DE_PROTOCOLOS, infoObj)
        },
        async gerarRelatorioReajustes(idVirtualizado, opcaoDownloadVirtualizacao){
            const infoObj ={
                idVirtualizado: idVirtualizado,
                opcaoDownloadVirtualizacao: opcaoDownloadVirtualizacao
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.BAIXAR_RELATORIO_DE_REAJUSTES, infoObj)
        },
        async gerarRelatorioReajustesNaoVirtualizado(){
            await this.$store.dispatch(actionTypes.FORNECEDOR.BAIXAR_RELATORIO_DE_REAJUSTES_NAO_VIRTUALIZADO, {
                compraDiretaId:this.compraDiretaId
            })
        },
        async gerarRelatorioProtocoloPreview(){
            const infoObj={
                compraDiretaId: this.compraDiretaId,
                propostaId: this.propostaId
            }
            await this.$store.dispatch(actionTypes.FORNECEDOR.BAIXAR_RELATORIO_DE_PROTOCOLO_PREVIEW, infoObj)
        },
        async tratarEventDownloadAnexo(documento){
            const info = {
                uri: documento.uri,
                nome: this.getNome(documento)
            }

            await this.$store.dispatch(actionTypes.DOWNLOAD_ANEXO, info)
        },
        getNome(documento){
            if(documento.descricao)
                return documento.descricao.replaceAll(' ', '_')
            return documento.uri.substring(documento.uri.lastIndexOf('/') + 1)
        },
        async eventoEnviarAnexoReadequacao(anexo) {
            const {arquivo} = await this.$store.dispatch(actionTypes.UPLOAD_ARQUIVO_SEM_LOKI, anexo)
            this.anexoReadequacao = arquivo
        },
        resetAnexoReadequacao(){ this.anexoReadequacao = null },
        async atualizarReadequacaoItemLote(dados) {
            await this.$store.dispatch(actionTypes.FORNECEDOR.ATUALIZAR_READEQUACAO_ITEM_LOTE, dados)
            this.mostrarNotificacaoSucesso('Operação realizada com sucesso!')
            this.anexoReadequacao = null
        }
    }
}
</script>

